import axios from 'axios';
import {
  API_INVENTORY_BASE_URL,
  API_PROJECT_BASE_URL,
  API_TASK_BASE_URL,
  API_USER_BASE_URL,
} from '../../apiConstant';
import {
  getDateAndTimeModifiedFormat,
} from '../commonUtils';
export async function getItemLastBills(inventoryDetailsId, limit = 5) {
  try {
    const resp = await axios.get(`${API_INVENTORY_BASE_URL}/workOrder/itemLastBills?inventoryDetailsId=${inventoryDetailsId}&limit=${limit}`);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
}

/**
 * Users API
 */

export async function getUsers(opts = {}) {
  try {
    const {
      sortBy = 'username',
      sort = 'asc',
      pageNumber = 0,
      pageSize = 250,
      filterValue = '',
    } = opts;
    let url = `${API_USER_BASE_URL}/api/user?sortBy=${sortBy}&sort=${sort}&pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (filterValue) {
      url += `&filterValue=${filterValue}`;
    }
    const resp = await axios.get(url);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
}

export async function getUsersConditional(opts = {}) {
  try {
    const {
      pageNumber = 0,
      pageSize = 100,
      filterValue = '',
      projectId = -1,
    } = opts;

    let url = '';
    let params = {};

    if (projectId && Number(projectId) !== -1) {
      url = `${API_PROJECT_BASE_URL}/api/projects/${projectId}/users`;
      params = {
        page: pageNumber,
        size: pageSize,
        filterValue: filterValue,
      };
    } else {
      url = `${API_USER_BASE_URL}/api/user/available`;
      params = {
        projectId: -1,
        pageNumber: pageNumber,
        pageSize: pageSize,
        filterValue: filterValue,
      };
    }

    const resp = await axios.get(url, { params });
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      // Handle project endpoint returning raw list vs available endpoint returning content object
      const data = resp.data?.content || resp.data || [];
      // Normalize to return object with content for InfiniteScrollDropdown compatibility if needed
      // Actually InfiniteScrollDropdown expectation is based on getNextPageParam
      // But let's return it consistently
      if (Array.isArray(data)) {
        return {
          content: data,
          last: true, // simplified for non-paginated or first page
          number: pageNumber,
        };
      }
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
}

/**
 * Room Type / Warehouse type
 */
export const getWarehousesType = async (opts = {}) => {
  try {
    const {
    } = opts;
    const resp = await axios.get(`${API_INVENTORY_BASE_URL}/room-type`);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const newWarehouseType = async (data) => {
  try {
    const resp = await axios.post(`${API_INVENTORY_BASE_URL}/room-type`, data);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const updateWarehouseType = async (id, data) => {
  try {
    const resp = await axios.put(
      `${API_INVENTORY_BASE_URL}/room-type/${id}`,
      data
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const deleteWarehouseType = async (id) => {
  try {
    const resp = await axios.delete(
      `${API_INVENTORY_BASE_URL}/room-type/${id}`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

/**
 * Room / Warehouse
 */
export const getWarehouses = async (opts = {}) => {
  try {
    const {
      sortBy = 'roomName',
      sort = 'asc',
      pageNumber = 0,
      pageSize = 250,
      searchString = '',
    } = opts;
    let url = `${API_INVENTORY_BASE_URL}/room?sortBy=${sortBy}&sort=${sort}&pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (searchString) {
      url += `&searchString=${searchString}`;
    }
    const resp = await axios.get(url);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

/**
 * Room / Warehouse Paginated
 */
export const getWarehousesPaginated = async (opts = {}) => {
  try {
    const {
      sortBy = 'roomName',
      sort = 'asc',
      pageNumber = 0,
      pageSize = 20,
      searchString = '',
    } = opts;
    let url = `${API_INVENTORY_BASE_URL}/room/pageData?sortBy=${sortBy}&sort=${sort}&pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (searchString) {
      url += `&searchString=${searchString}`;
    }
    const resp = await axios.get(url);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getWarehousesByUser = async (opts = {}) => {
  try {
    const {
      sortBy = 'roomName',
      sort = 'asc',
      pageNumber = 0,
      pageSize = 250,
      searchString = '',
    } = opts;
    let url = `${API_INVENTORY_BASE_URL}/room/byUsers?sortBy=${sortBy}&sort=${sort}&pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (searchString) {
      url += `&searchString=${searchString}`;
    }
    const resp = await axios.get(url);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getOneWarehouse = async (id) => {
  try {
    const resp = await axios.get(`${API_INVENTORY_BASE_URL}/room/${id}`);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const newWarehouse = async (data) => {
  try {
    const resp = await axios.post(`${API_INVENTORY_BASE_URL}/room`, data);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const updateWarehouse = async (data) => {
  try {
    const resp = await axios.post(`${API_INVENTORY_BASE_URL}/room`, data);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const deleteWarehouse = async (id) => {
  try {
    const resp = await axios.delete(`${API_INVENTORY_BASE_URL}/room/${id}`);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const deleteEmployee = async (id) => {
  try {
    const resp = await axios.delete(`${API_USER_BASE_URL}/api/user/${id}`);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const deleteTask = async (id) => {
  try {
    const resp = await axios.delete(`${API_TASK_BASE_URL}/api/tasks/${id}`);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

/**
 * Materials Indent API
 */

export const getMaterialsIndentList = async (opts = {}) => {
  try {
    const {
      sortBy = 'createdOn',
      sort = 'desc',
      pageNumber = 0,
      pageSize = 20,
      raisedByIds = [],
      toSiteIds = [],
      status = '',
    } = opts;
    let url = `${API_INVENTORY_BASE_URL}/materialIndent?sortBy=${sortBy}&sort=${sort}&pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (raisedByIds) {
      url += `&raisedByIds=${raisedByIds}`;
    }
    if (toSiteIds) {
      url += `&toSiteIds=${toSiteIds}`;
    }
    if (status) {
      url += `&status=${status}`;
    }
    if (opts.materialIndentId) {
      url += `&materialIndentId=${opts.materialIndentId}`;
    }
    if (opts.searchString) {
      url += `&searchString=${opts.searchString}`;
    }
    const resp = await axios.get(url);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getProjectMaterialIndentList = async (projectId, opts = {}) => {
  try {
    const {
      sortBy = 'createdOn',
      sort = 'desc',
      pageNumber = 0,
      pageSize = 20,
      status = '',
    } = opts;
    let url = `${API_INVENTORY_BASE_URL}/materialIndent?sortBy=${sortBy}&sort=${sort}&pageNumber=${pageNumber}&pageSize=${pageSize}&projectId=${projectId}&raisedByIds=&toSiteIds=`;

    if (status) {
      url += `&status=${status}`;
    }
    if (opts.materialIndentId) {
      url += `&materialIndentId=${opts.materialIndentId}`;
    }
    if (opts.searchString) {
      url += `&searchString=${opts.searchString}`;
    }
    if (opts.start) {
      url += `&start=${getDateAndTimeModifiedFormat(opts.start)}`;
    }
    if (opts.end) {
      url += `&end=${getDateAndTimeModifiedFormat(opts.end)}`;
    }

    const resp = await axios.get(url);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getProjectPurchaseOrderList = async (projectId, opts = {}) => {
  try {
    const {
      sortBy = 'createdOn',
      sort = 'desc',
      pageNumber = 0,
      pageSize = 20,
      status = '',
    } = opts;

    let url = `${API_INVENTORY_BASE_URL}/workOrder/getWorkOrdersAll?sortBy=${sortBy}&sort=${sort}&pageNumber=${pageNumber}&pageSize=${pageSize}&projectId=${projectId}&raisedByIds=`;
    if (status) {
      url += `&status=${status}`;
    }
    if (opts.workOrderId) {
      url += `&workOrderId=${opts.workOrderId}`;
    }
    if (opts.searchString) {
      url += `&searchString=${opts.searchString}`;
    }
    if (opts.start) {
      url += `&start=${new Date(opts.start).toISOString().split('T')[0]}`;
    }

    if (opts.end) {
      url += `&end=${new Date(opts.end).toISOString().split('T')[0]}`;
    }
    const resp = await axios.get(url);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getProjectStocksList = async (projectId, opts = {}) => {
  try {
    const {
      sortBy = 'inventoryDetails.inventoryName',
      sort = 'asc',
      pageNumber = 0,
      pageSize = 20,
      inventoryDetailsIds = '',
      inventoryDetailsParentId = '',
      inventoryTypeId = '',
      searchString = '',
      star = null,
      excludeZeroStock = null,
      excludeZeroUtilized = null,
    } = opts;

    const roomResp = await axios.get(
      `${API_INVENTORY_BASE_URL}/room/project/${projectId}`
    );
    const projectRoom = roomResp.data;

    if (!projectRoom?.roomId) {
      throw new Error('No room found for this project');
    }

    let url = `${API_INVENTORY_BASE_URL}/stock?sortBy=${sortBy}&sort=${sort}&pageNumber=${pageNumber}&pageSize=${pageSize}&inventoryDetailsIds=${inventoryDetailsIds}&roomIds=${projectRoom.roomId}&inventoryDetailsParentId=${inventoryDetailsParentId}&inventoryTypeId=${inventoryTypeId}`;

    if (searchString) url += `&searchString=${searchString}`;
    if (star) url += `&star=${star}`;

    // ALWAYS SEND excludeZeroStock
    url += `&excludeZeroStock=${excludeZeroStock}`;
    url += `&excludeZeroUtilized=${excludeZeroUtilized}`;

    const resp = await axios.get(url);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getTaskStocksList = async (projectId, taskId, opts = {}) => {
  try {
    const {
      sortBy = 'inventoryDetailsName',
      sort = 'asc',
      pageNumber = 0,
      pageSize = 100,
      searchString = '',
    } = opts;

    let url = `${API_INVENTORY_BASE_URL}/stock/byTaskId?taskId=${taskId}&sortBy=${sortBy}&sort=${sort}&pageNumber=${pageNumber}&pageSize=${pageSize}`;

    if (searchString) url += `&searchString=${searchString}`;

    const resp = await axios.get(url);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getProjectLogisticsList = async (projectId, opts = {}) => {
  try {
    const {
      sortBy = 'createdOn',
      sort = 'desc',
      pageNumber = 0,
      pageSize = 20,
      searchString = '',
      start = null,
      end = null,
    } = opts;

    let url = `${API_INVENTORY_BASE_URL}/logistics?sortBy=${sortBy}&sort=${sort}&pageNumber=${pageNumber}&pageSize=${pageSize}&projectId=${projectId}`;

    if (searchString) {
      url += `&searchStr=${searchString}`;
    }
    if (start) {
      url += `&start=${start}`;
    }
    if (end) {
      url += `&end=${end}`;
    }

    const resp = await axios.get(url);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const newMaterialsIndent = async (data) => {
  try {
    const resp = await axios.post(
      `${API_INVENTORY_BASE_URL}/materialIndent`,
      data
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getOneMaterialsIndent = async (id) => {
  try {
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/materialIndent/${id}`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const updateOneMaterialsIndent = async (id, data) => {
  try {
    const resp = await axios.put(
      `${API_INVENTORY_BASE_URL}/materialIndent`,
      data
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const updateMiStatus = async (id, status) => {
  try {
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/materialIndent/updateStatus?mid=${id}&status=${status}`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const approveMI = async (id, role, data = {}) => {
  try {
    const resp = await axios.put(
      `${API_INVENTORY_BASE_URL}/materialIndent/${role}/approve/${id}`,
      data
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const approveMessageMI = async (id) => {
  try {
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/materialIndent/approveMessage/${id}`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const materialIndentDecision = async (data) => {
  try {
    const resp = await axios.put(
      `${API_INVENTORY_BASE_URL}/materialIndent/decision`,
      data
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const materialIndentUpdatePoLogistic = async (data) => {
  try {
    const resp = await axios.put(
      `${API_INVENTORY_BASE_URL}/materialIndent/updatePoLogistic`,
      data
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getindentedMaterialQuantities = async (type) => {
  try {
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/materialIndent/indentedMaterialQuantities/${type}`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getMaterialIndentProgressStatusList = async (type) => {
  try {
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/materialIndent/getMaterialIndentProgressStatusList`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const deleteMI = async (id) => {
  try {
    const resp = await axios.delete(
      `${API_INVENTORY_BASE_URL}/materialIndent/${id}`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getMIPdf = async (id) => {
  try {
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/materialIndent/getPdf?miId=${id}`,
      { responseType: 'blob' }
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

/**
 * Category, subcat etc
 */

export const inventoryDetails = async (opts = {}) => {
  try {
    const {
      sortBy = 'inventoryName',
      sort = 'asc',
      pageNumber = 0,
      pageSize = 30,
      searchString = '',
      inventoryDetailsParentId = '',
    } = opts;
    let url = `${API_INVENTORY_BASE_URL}/inventoryDetails?sortBy=${sortBy}&sort=${sort}&pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (searchString) {
      url += `&searchString=${searchString}`;
    }
    if (inventoryDetailsParentId) {
      url += `&inventoryDetailsParentId=${inventoryDetailsParentId}`;
    }
    const resp = await axios.get(url);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const inventoryDetailsProjectWise = async (opts = {}) => {
  try {
    const {
      projectId,
      sortBy = 'inventoryName',
      sort = 'asc',
      pageNumber = 0,
      pageSize = 30,
      searchString = '',
      inventoryDetailsParentId = '',
    } = opts;

    let url = `${API_INVENTORY_BASE_URL}/inventoryDetailsProjectWise?projectId=${projectId}&sortBy=${sortBy}&sort=${sort}&pageNumber=${pageNumber}&pageSize=${pageSize}`;

    if (searchString) {
      url += `&searchString=${encodeURIComponent(searchString)}`;
    }

    if (inventoryDetailsParentId) {
      url += `&inventoryDetailsParentId=${inventoryDetailsParentId}`;
    }

    const resp = await axios.get(url);

    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    }

    return resp.data;
  } catch (error) {
    throw error;
  }
};

export const getAllMachinery = async (opts = {}) => {
  try {
    const {
      searchString = '',
      machineryTypeId = '',
    } = opts;

    let url = `${API_INVENTORY_BASE_URL}/field-items/getAll`;

    if (searchString) {
      url += `&searchString=${encodeURIComponent(searchString)}`;
    }

    if (machineryTypeId) {
      url += `&machineryTypeId=${machineryTypeId}`;
    }

    const resp = await axios.get(url);

    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    }

    return resp.data;
  } catch (error) {
    throw error;
  }
};

export const getAllAssignedMachinery = async (opts = {}) => {
  try {
    const {
      sortBy = 'updatedOn',
      sort = 'desc',
      pageNumber = 0,
      pageSize = 20,
      projectId,
    } = opts;

    let url = `${API_INVENTORY_BASE_URL}/field-items/assigned?sortBy=${sortBy}&sort=${sort}&pageNumber=${pageNumber}&pageSize=${pageSize}`;

    if (projectId) {
      url += `&id=${projectId}`;
    }

    const resp = await axios.get(url);

    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    }

    return resp.data;
  } catch (error) {
    throw error;
  }
};

export const deleteAssignedMachinery = async (id) => {
  const resp = await axios.delete(
    `${API_INVENTORY_BASE_URL}/field-items/${id}`
  );

  if (resp.data?.pmsExceptionCode) {
    throw resp.data;
  }

  return resp.data;
};

export const updateAssignedMachinery = async (id, payload) => {
  try {
    const resp = await axios.put(`${API_INVENTORY_BASE_URL}/field-items/assigned/${id}`, payload);
    if (resp?.data?.pmsExceptionCode) {
      throw resp.data;
    }
    return resp.data;
  } catch (error) {
    throw error;
  }
};

export const updateFieldItem = async (id, payload) => {
  try {
    const resp = await axios.put(`${API_INVENTORY_BASE_URL}/field-items/${id}`, payload);
    if (resp?.data?.pmsExceptionCode) {
      throw resp.data;
    }
    return resp.data;
  } catch (error) {
    throw error;
  }
};

export const fetchMaterialClientPriceAPI = async ({
  inventoryDetailsId,
  projectId,
}) => {
  try {
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/inventoryDetailsProjectWise/price`,
      {
        params: {
          itemId: inventoryDetailsId,
          projectId: projectId,
        },
      }
    );

    if (resp.data?.pmsExceptionCode) {
      const err = new Error(resp.data.message || 'Failed to fetch item price');
      err.code = resp.data.pmsExceptionCode;
      throw err;
    }

    return resp.data; // expected to return price info
  } catch (error) {
    throw error;
  }
};

export const assignFieldItemsToProject = async (payload) => {
  try {
    const resp = await axios.post(
      `${API_INVENTORY_BASE_URL}/field-items/assignToProject`,
      payload
    );

    // API error returned inside 2xx
    if (resp?.data?.pmsExceptionCode) {
      const message =
        resp.data.message || `API error: ${resp.data.pmsExceptionCode}`;

      const err = new Error(message);
      err.code = resp.data.pmsExceptionCode;
      err.details = resp.data;
      throw err;
    }

    return resp.data;
  } catch (err) {
    // Axios error → rethrow as-is
    if (err?.isAxiosError) {
      throw err;
    }

    // Normal JS error
    if (err instanceof Error) {
      throw err;
    }

    // Fallback (non-standard error)
    throw new Error(JSON.stringify(err));
  }
};

export const addFieldItem = async (data) => {
  try {
    const resp = await axios.post(
      `${API_INVENTORY_BASE_URL}/field-items/add`,
      data
    );

    if (resp?.data?.pmsExceptionCode) {
      const err = new Error(
        resp.data.message || `API error: ${resp.data.pmsExceptionCode}`
      );
      err.code = resp.data.pmsExceptionCode;
      err.details = resp.data;
      throw err;
    }

    return resp.data;
  } catch (err) {
    // Axios error → rethrow as-is
    if (err?.isAxiosError) throw err;

    // Normal JS error
    if (err instanceof Error) throw err;

    // Fallback
    throw new Error(JSON.stringify(err));
  }
};

export const createInventoryDetailsProjectWise = async (data) => {
  try {
    const resp = await axios.post(
      `${API_INVENTORY_BASE_URL}/inventoryDetailsProjectWise`,
      data
    );

    if (resp?.data?.pmsExceptionCode) {
      const err = new Error(
        resp.data.message || `API error: ${resp.data.pmsExceptionCode}`
      );
      err.code = resp.data.pmsExceptionCode;
      err.details = resp.data;
      throw err;
    }

    return resp.data;
  } catch (err) {
    if (err?.isAxiosError) throw err;
    if (err instanceof Error) throw err;
    throw new Error(JSON.stringify(err));
  }
};

export const updateInventoryDetailsProjectWise = async (id, data) => {
  console.log(data);
  try {
    const resp = await axios.put(
      `${API_INVENTORY_BASE_URL}/inventoryDetailsProjectWise/${id}`,
      {
        projectId: data?.projectId,
        price: data?.price,
      }
    );

    // API-level error wrapped in 2xx
    if (resp?.data?.pmsExceptionCode) {
      const err = new Error(
        resp.data.message || `API error: ${resp.data.pmsExceptionCode}`
      );
      err.code = resp.data.pmsExceptionCode;
      err.details = resp.data;
      throw err;
    }

    return resp.data;
  } catch (err) {
    if (err?.isAxiosError) throw err;
    if (err instanceof Error) throw err;
    throw new Error(JSON.stringify(err));
  }
};

export const deleteInventoryDetailsProjectWise = async (id) => {
  const resp = await axios.delete(
    `${API_INVENTORY_BASE_URL}/inventoryDetailsProjectWise/${id}`
  );

  if (resp?.data?.pmsExceptionCode) {
    throw resp.data;
  }

  return resp.data;
};

export const newInventoryDetails = async (body) => {
  try {
    const resp = await axios.post(
      `${API_INVENTORY_BASE_URL}/inventoryDetails`,
      body
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const editInventoryDetailsById = async (inventoryDetailsId, body) => {
  try {
    const resp = await axios.put(
      `${API_INVENTORY_BASE_URL}/inventoryDetails/${inventoryDetailsId}`,
      body
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const deleteInventoryDetailsById = async (inventoryDetailsId) => {
  try {
    const resp = await axios.delete(
      `${API_INVENTORY_BASE_URL}/inventoryDetails/${inventoryDetailsId}`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const inventoryDetailsByParentsInventoryId = async (
  inventoryDetailsParentId
) => {
  try {
    let url = `${API_INVENTORY_BASE_URL}/inventoryDetails/byInventoryDetailsParent/${inventoryDetailsParentId}`;
    const resp = await axios.get(url);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const inventoryDetailsParent = async (opts = {}) => {
  try {
    const {
      sortBy = 'inventoryParentName',
      sort = 'asc',
      pageNumber = 0,
      pageSize = 30,
      searchString = '',
    } = opts;
    let url = `${API_INVENTORY_BASE_URL}/inventoryDetailsParent?sortBy=${sortBy}&sort=${sort}&pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (searchString) {
      url += `&searchString=${searchString}`;
    }
    const resp = await axios.get(url);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const inventoryDetailsParentsByInventoryTypeId = async (
  inventoryTypeId
) => {
  try {
    let url = `${API_INVENTORY_BASE_URL}/inventoryDetailsParent/byInventoryType/${inventoryTypeId}`;
    const resp = await axios.get(url);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const newInventoryDetailsParent = async (body) => {
  try {
    const resp = await axios.post(
      `${API_INVENTORY_BASE_URL}/inventoryDetailsParent`,
      body
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const ToggleAutoPo = async (id, state) => {
  try {
    const resp = await axios.put(
      `${API_INVENTORY_BASE_URL}/inventoryDetails/updateRaiseAutoPo?inventoryDetailsId=${id}&raiseAutoPo=${state}`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      window.triggerAlert({ title: 'Updated successfully', type: 'success' });
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const editInventoryDetailsParentById = async (
  inventoryDetailsParentId,
  body
) => {
  try {
    const resp = await axios.put(
      `${API_INVENTORY_BASE_URL}/inventoryDetailsParent/${inventoryDetailsParentId}`,
      body
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const deleteInventoryDetailsParentById = async (
  inventoryDetailsParentId
) => {
  try {
    const resp = await axios.delete(
      `${API_INVENTORY_BASE_URL}/inventoryDetailsParent/${inventoryDetailsParentId}`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getCategories = async (opts = {}) => {
  try {
    const {
      sortBy = 'inventoryType',
      sort = 'asc',
      pageNumber = 0,
      pageSize = 50,
      searchString = '',
    } = opts;
    let url = `${API_INVENTORY_BASE_URL}/inventoryType?sortBy=${sortBy}&sort=${sort}&pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (searchString) {
      url += `&searchString=${searchString}`;
    }
    const resp = await axios.get(url);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getCategoryDetails = async () => {
  try {
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/inventoryType/getInventoryDetailsPerTypeCount`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const newInventoryType = async (body) => {
  try {
    const resp = await axios.post(
      `${API_INVENTORY_BASE_URL}/inventoryType`,
      body
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const editInventoryTypeById = async (typeId, body) => {
  try {
    const resp = await axios.put(
      `${API_INVENTORY_BASE_URL}/inventoryType/${typeId}`,
      body
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const addInventoryType = async (body) => {
  try {
    const resp = await axios.post(
      `${API_INVENTORY_BASE_URL}/inventoryType`,
      body
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getOneInventoryTypeById = async (typeId) => {
  try {
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/inventoryType/${typeId}`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const deleteInventoryTypeById = async (typeId) => {
  try {
    const resp = await axios.delete(
      `${API_INVENTORY_BASE_URL}/inventoryType/${typeId}`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const deleteItemsById = async (typeId) => {
  try {
    const resp = await axios.delete(
      `${API_INVENTORY_BASE_URL}/inventoryDetails/${typeId}`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const deleteInventoryDetailsParentIdTypeById = async (typeId) => {
  try {
    const resp = await axios.delete(
      `${API_INVENTORY_BASE_URL}/inventoryDetailsParentId/${typeId}`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const deleteLogisticById = async (typeId) => {
  try {
    const resp = await axios.delete(
      `${API_INVENTORY_BASE_URL}/logistics/${typeId}`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const deletePoById = async (typeId) => {
  try {
    const resp = await axios.delete(
      `${API_INVENTORY_BASE_URL}/workOrder/${typeId}`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const deleteMiId = async (typeId) => {
  try {
    const resp = await axios.delete(
      `${API_INVENTORY_BASE_URL}/materialIndent/${typeId}`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getInventoryTypes = async () => {
  try {
    const resp = await axios.get(`${API_INVENTORY_BASE_URL}/inventoryType`);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getInventoryMovementEnum = async () => {
  try {
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/inventoryMovement/getMovementTypeEnum`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getInventoryStatusList = async () => {
  try {
    const resp = await axios.get(`${API_INVENTORY_BASE_URL}/inventoryStatus`);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

/**
 * PurchaseOrder / WorkOrder
 */

export const getPriorityEnum = async () => {
  try {
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/workOrder/getPriorityEnum`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getWorkOrderList = async (opts = {}) => {
  try {
    const {
      sortBy = 'createdOn',
      sort = 'desc',
      pageNumber = 0,
      pageSize = 20,
      raisedByIds = [],
      toSiteIds = [],
      searchString = '',
    } = opts;
    let url = `${API_INVENTORY_BASE_URL}/workOrder/getWorkOrdersAll?sortBy=${sortBy}&sort=${sort}&pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (searchString) {
      url += `&searchString=${searchString}`;
    }
    if (raisedByIds) {
      url += `&raisedById=${raisedByIds}`;
    }
    if (toSiteIds) {
      url += `&toSiteId=${toSiteIds}`;
    }
    const resp = await axios.get(url);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getWorkOrderStatusEnum = async () => {
  try {
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/workOrder/getWorkOrderStatusEnum`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const checkWorkOrder = async (data) => {
  try {
    const resp = await axios.post(
      `${API_INVENTORY_BASE_URL}/workOrder/check`,
      data
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};


export const newWorkOrder = async (data) => {
  try {
    const resp = await axios.post(`${API_INVENTORY_BASE_URL}/workOrder`, data);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const updateWorkOrder = async (id, data, approvalResetFlag = false) => {
  try {
    const resp = await axios.put(
      `${API_INVENTORY_BASE_URL}/workOrder?workOrderId=${id}&approvalResetFlag=${approvalResetFlag}`,
      data
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const approveWorkOrder = async (id, role, data = {}) => {
  try {
    const resp = await axios.put(
      `${API_INVENTORY_BASE_URL}/workOrder/approveWorkOrder?workOrderId=${id}&role=${role}`,
      data
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getWorkOrderById = async (id) => {
  try {
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/workOrder/workOrdersById?workOrderId=${id}`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const updateCompleteWorkOrder = async (id, data = {}) => {
  try {
    const resp = await axios.put(
      `${API_INVENTORY_BASE_URL}/workOrder/completeWorkOrder/${id}`,
      data
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const addFromRoomToWorkOrder = async (id, stockId) => {
  try {
    const resp = await axios.put(
      `${API_INVENTORY_BASE_URL}/workOrder/addFromRoom?workOrderId=${id}&stockId=${stockId}`,
      {}
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const updateWorkOrderProgress = async (id, status) => {
  try {
    const resp = await axios.put(
      `${API_INVENTORY_BASE_URL}/workOrder/workOrderProgress?workOrderId=${id}&workOrderStatusEnum=${status}`,
      {}
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const workOrderByMaterialIndentId = async (id) => {
  try {
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/workOrder/workOrderByMaterialIndentId/${id}`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const completePO = async (body) => {
  try {
    const resp = await axios.put(
      `${API_INVENTORY_BASE_URL}/completion/completePo`,
      body
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const returnStock = async (body) => {
  try {
    const resp = await axios.post(
      `${API_INVENTORY_BASE_URL}/workOrder/returnStock`,
      body
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const exchangeStock = async (body) => {
  try {
    const resp = await axios.post(
      `${API_INVENTORY_BASE_URL}/workOrder/exchangeStock`,
      body
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const deletePO = async (poId) => {
  try {
    const resp = await axios.delete(
      `${API_INVENTORY_BASE_URL}/workOrder?poId=${poId}`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const approveMessagePo = async (id) => {
  try {
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/workOrder/approveMessage?workOrderId=${id}`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

/**
 * Fetch internal purchase list with start/end dates expanded to full-day times.
 *
 * opts:
 *  - sortBy (string) default 'purchasedDate'
 *  - sortDir ('asc'|'desc') default 'desc'
 *  - pageNumber (number) default 0 (0-based paging)
 *  - pageSize (number) default 10
 *  - search (string)
 *  - start (string) YYYY-MM-DD or YYYY-MM-DD HH:MM:SS
 *  - end (string) YYYY-MM-DD or YYYY-MM-DD HH:MM:SS
 *  - signal (AbortSignal) optional
 *  - timeout (number) ms default 10000
 *
 * Behavior:
 *  - If start is a date only (YYYY-MM-DD) it will be converted to "YYYY-MM-DD 00:00:00"
 *  - If end is a date only (YYYY-MM-DD) it will be converted to "YYYY-MM-DD 23:59:59"
 *  - Query string is generated via URLSearchParams to serialize spaces as '+' (e.g. "2025-09-01+00:00:00")
 */
export const getInternalPurchaseList = async (opts = {}) => {
  const {
    sortBy = 'purchasedDate',
    sortDir = 'desc',
    pageNumber = 0,
    pageSize = 10,
    search = '',
    start = '',
    end = '',
    signal,
    toSiteId,
    timeout = 10000,
    isFromUserRoute = false,
  } = opts;

  // Basic validations/coercions
  const allowedSortDir = new Set(['asc', 'desc']);
  const dir = allowedSortDir.has(String(sortDir).toLowerCase())
    ? String(sortDir).toLowerCase()
    : 'desc';

  const pageNum = Math.max(0, Number(pageNumber) || 0);
  const pSize = Math.max(1, Number(pageSize) || 10);

  // Accept either date-only (YYYY-MM-DD) or full datetime (YYYY-MM-DD HH:MM:SS)
  const dateOnlyRe = /^\d{4}-\d{2}-\d{2}$/;
  const dateOrDatetimeRe = /^\d{4}-\d{2}-\d{2}(?:[ T]\d{2}:\d{2}:\d{2})?$/;

  let startVal = start;
  let endVal = end;

  if (startVal) {
    if (!dateOrDatetimeRe.test(startVal)) {
      throw new Error(
        `Invalid start date/time format: ${startVal}. Expected YYYY-MM-DD or YYYY-MM-DD HH:MM:SS`
      );
    }
    if (dateOnlyRe.test(startVal)) {
      startVal = `${startVal} 00:00:00`;
    } else {
      // normalize separator to space if user passed 'T'
      startVal = startVal.replace('T', ' ');
    }
  }

  if (endVal) {
    if (!dateOrDatetimeRe.test(endVal)) {
      throw new Error(
        `Invalid end date/time format: ${endVal}. Expected YYYY-MM-DD or YYYY-MM-DD HH:MM:SS`
      );
    }
    if (dateOnlyRe.test(endVal)) {
      endVal = `${endVal} 23:59:59`;
    } else {
      endVal = endVal.replace('T', ' ');
    }
  }

  if (startVal && endVal && startVal > endVal) {
    throw new Error(
      `Invalid date range: start (${startVal}) is after end (${endVal}).`
    );
  }

  // Build query using URLSearchParams so spaces become '+' as requested
  const params = new URLSearchParams();
  params.set('sortBy', sortBy);
  params.set('sortDir', dir);
  params.set('pageNumber', String(pageNum));
  params.set('pageSize', String(pSize));
  if (toSiteId) params.set('toSiteId', toSiteId);
  if (search) params.set('search', search);
  if (startVal) params.set('start', startVal);
  if (endVal) params.set('end', endVal);


  const url = isFromUserRoute
    ? `${API_INVENTORY_BASE_URL}/internalPurchase/byUser?${params.toString()}`
    : `${API_INVENTORY_BASE_URL}/internalPurchase/v2?${params.toString()}`;

  try {
    const resp = await axios.get(url, { timeout, signal });

    // Domain-level API error returned inside 2xx
    if (resp?.data?.pmsExceptionCode) {
      const message =
        resp.data.message || `API error: ${resp.data.pmsExceptionCode}`;
      const err = new Error(message);
      err.code = resp.data.pmsExceptionCode;
      err.details = resp.data;
      throw err;
    }

    return resp.data;
  } catch (err) {
    if (err && err.isAxiosError) throw err;

    if (err instanceof Error) throw err;

    throw new Error(JSON.stringify(err));
  }
};

/**
 * Create a new internal purchase
 * @param {Object} data - Internal purchase data
 * @returns {Promise} - API response
 */
export const createInternalPurchase = async (data) => {
  try {
    const resp = await axios.post(
      `${API_INVENTORY_BASE_URL}/internalPurchase/v2`,
      data
    );

    // API error returned inside 2xx
    if (resp?.data?.pmsExceptionCode) {
      const message =
        resp.data.message || `API error: ${resp.data.pmsExceptionCode}`;
      const err = new Error(message);
      err.code = resp.data.pmsExceptionCode;
      err.details = resp.data;
      throw err;
    }

    return resp.data;
  } catch (err) {
    if (err && err.isAxiosError) throw err;

    if (err instanceof Error) throw err;

    throw new Error(JSON.stringify(err));
  }
};

export const getInternalPurchaseById = async (id) => {
  try {
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/internalPurchase/v2/byId`,
      { params: { id } }
    );

    // API error returned inside 2xx
    if (resp?.data?.pmsExceptionCode) {
      const message =
        resp.data.message || `API error: ${resp.data.pmsExceptionCode}`;
      const err = new Error(message);
      err.code = resp.data.pmsExceptionCode;
      err.details = resp.data;
      throw err;
    }

    return resp.data;
  } catch (err) {
    if (err && err.isAxiosError) {
      throw err;
    }

    if (err instanceof Error) {
      throw err;
    }

    throw new Error(JSON.stringify(err));
  }
};

export const updateInternalPurchase = async (purchaseId, data) => {
  try {
    const resp = await axios.put(
      `${API_INVENTORY_BASE_URL}/internalPurchase/v2/${purchaseId}`,
      data
    );

    if (resp?.data?.pmsExceptionCode) {
      const message =
        resp.data.message || `API error: ${resp.data.pmsExceptionCode}`;
      const err = new Error(message);
      err.code = resp.data.pmsExceptionCode;
      err.details = resp.data;
      throw err;
    }

    return resp.data;
  } catch (err) {
    if (err?.isAxiosError) throw err;

    if (err instanceof Error) throw err;

    throw new Error(JSON.stringify(err));
  }
};

/**
 * Delete internal purchase by ID
 * @param {number|string} id - Internal purchase ID to delete
 * @returns {Promise} - API response
 */
export const deleteInternalPurchase = async (id) => {
  try {
    const resp = await axios.delete(
      `${API_INVENTORY_BASE_URL}/internalPurchase?id=${id}`
    );

    if (resp?.data?.pmsExceptionCode) {
      const message =
        resp.data.message || `API error: ${resp.data.pmsExceptionCode}`;
      const err = new Error(message);
      err.code = resp.data.pmsExceptionCode;
      err.details = resp.data;
      throw err;
    }

    return resp.data;
  } catch (err) {
    if (err && err.isAxiosError) throw err;

    if (err instanceof Error) throw err;

    throw new Error(JSON.stringify(err));
  }
};

export const fetchAdvanceSummary = async (page, pageSize, isFromUserRoute) => {
  const url = isFromUserRoute
    ? `${API_INVENTORY_BASE_URL}/internalPurchase/advance/summary/byUser` //for user
    : `${API_INVENTORY_BASE_URL}/internalPurchase/advance/summary/users`;

  const response = await axios.get(url, {
    params: {
      sortBy: 'paidTo',
      sortDir: 'asc',
      pageNumber: page,
      pageSize: pageSize,
    },
  });
  return response.data;
};

/**
 * Bills
 */

export const newPoBill = async (body, poId, billNumber) => {
  try {
    const resp = await axios.post(
      `${API_INVENTORY_BASE_URL}/poBill?workOrderId=${poId}&billNumber=${billNumber}`,
      body
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getPoBill = async (poBillId) => {
  try {
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/poBill?poBillId=${poBillId}`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const updatePoBill = async (poBillId, billNumber, body) => {
  try {
    const resp = await axios.put(
      `${API_INVENTORY_BASE_URL}/poBill?poBillId=${poBillId}&billNumber=${billNumber}`,
      body
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const deletePoBill = async (PoBillId) => {
  try {
    const resp = await axios.delete(
      `${API_INVENTORY_BASE_URL}/poBill?PoBillId=${PoBillId}`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const poBillUpdatePaymentStatus = async (poBillId, status) => {
  try {
    const resp = await axios.put(
      `${API_INVENTORY_BASE_URL}/poBill/updatePaymentStatus?poBillId=${poBillId}&status=${status}`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getPoBillsList = async (opts = {}) => {
  try {
    const {
      sortBy = 'userName',
      sort = 'asc',
      pageNumber = 0,
      pageSize = 20,
      raisedByIds = [],
      toSiteIds = [],
      searchString = '',
    } = opts;
    let url = `${API_INVENTORY_BASE_URL}/poBill/getPoBillsAll?sortBy=${sortBy}&sort=${sort}&pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (searchString) {
      url += `&searchString=${searchString}`;
    }
    if (raisedByIds) {
      url += `&raisedByIds=${raisedByIds}`;
    }
    if (toSiteIds) {
      url += `&toSiteIds=${toSiteIds}`;
    }
    const resp = await axios.get(url);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const approvePoBill = async (billId, role) => {
  try {
    const resp = await axios.put(
      `${API_INVENTORY_BASE_URL}/poBill/approveWorkOrder?billId=${billId}&role=${role}`
    );
    return resp.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Update the status of a PO Bill.
 *
 * @param {number} billId - The ID of the PO Bill to update.
 * @param {string} status - The new status to set. Available values: CREATED, PM_APPROVED, TH_APPROVED, COO_APPROVED, HOLD, PO_RAISED, DELIVERY_UPDATED, COMPLETED.
 * @returns {Promise<Object>} The response data from the API.
 * @throws Will throw an error if the API call fails.
 */
export const updatePOBillStatus = async (billId, status) => {
  try {
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/poBill/updateStatus?poBillId=${billId}&status=${status}`
    );
    return resp.data;
  } catch (error) {
    throw error;
  }
};

export const approveMessagePoBill = async (id) => {
  try {
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/poBill/approveMessage?poBillId=${id}`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getBillDetailsByRoom = async (roomId) => {
  try {
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/poBill/getBillDetailsByRoom?roomId=${roomId}`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};
/**
 * Vendor
 */

export const getVendors = async (opts = {}) => {
  try {
    const {
      sortBy = 'createdOn',
      sort = 'desc',
      pageNumber = 0,
      pageSize = 20,
      searchName = '',
    } = opts;
    let url = `${API_INVENTORY_BASE_URL}/vendor?sortBy=${sortBy}&sort=${sort}&pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (searchName) {
      url += `&searchName=${searchName}`;
    }
    const resp = await axios.get(url);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const newVendor = async (data) => {
  try {
    const resp = await axios.post(`${API_INVENTORY_BASE_URL}/vendor`, data);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const updateVendor = async (id, data) => {
  try {
    const resp = await axios.put(`${API_INVENTORY_BASE_URL}/vendor`, data);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getVendorTypes = async () => {
  try {
    const resp = await axios.get(`${API_INVENTORY_BASE_URL}/vendor/vendorType`);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const deleteVendor = async (id) => {
  try {
    const resp = await axios.delete(`${API_INVENTORY_BASE_URL}/vendor/delete/${id}`);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getOneVendor = async (id) => {
  try {
    const resp = await axios.get(`${API_INVENTORY_BASE_URL}/vendor/${id}`);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

/**
 * Stock
 */

export const getStocks = async (opts = {}) => {
  try {
    const {
      sortBy = '',
      sort = 'desc',
      pageNumber = 0,
      pageSize = 20,
      inventoryDetailsIds = [],
      roomIds = [],
      inventoryDetailsParentId = [],
      inventoryTypeId = [],
      searchString = '',
      star = null,
      excludeZeroStock = false,
    } = opts;
    let url = `${API_INVENTORY_BASE_URL}/stock?sortBy=${sortBy}&sort=${sort}&pageNumber=${pageNumber}&pageSize=${pageSize}&inventoryTypeId=${inventoryTypeId}&inventoryDetailsIds=${inventoryDetailsIds}&roomIds=${roomIds}&inventoryDetailsParentId=${inventoryDetailsParentId}`;
    if (searchString) {
      url += `&searchString=${searchString}`;
    }
    if (star) {
      url += `&star=${star}`;
    }
    // ALWAYS SEND excludeZeroStock
    url += `&excludeZeroStock=${excludeZeroStock}`;
    const resp = await axios.get(url);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getStocksByUser = async (opts = {}) => {
  try {
    const {
      sortBy = '',
      sort = 'desc',
      pageNumber = 0,
      pageSize = 20,
      inventoryDetailsIds = [],
      roomIds = [],
      inventoryDetailsParentId = [],
      searchString = '',
      star = null,
    } = opts;
    let url = `${API_INVENTORY_BASE_URL}/stock/byUser?sortBy=${sortBy}&sort=${sort}&pageNumber=${pageNumber}&pageSize=${pageSize}&inventoryDetailsIds=${inventoryDetailsIds}&roomIds=${roomIds}&inventoryDetailsParentId=${inventoryDetailsParentId}`;
    if (searchString) {
      url += `&searchString=${searchString}`;
    }
    if (star) {
      url += `&star=${star}`;
    }
    const resp = await axios.get(url);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

/**
 * Get stock quantities for a specific room and list of materials.
 * @param {Object} data - { roomId, inventoryDetailsIds }
 * @returns {Promise<Array>} List of { inventoryDetailsId, stockQuantity }
 */
export const getStockQuantities = async (data) => {
  try {
    const resp = await axios.post(
      `${API_INVENTORY_BASE_URL}/stock/quantities`,
      data
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getActionLog = async (stockId) => {
  try {
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/stock/getActionLog?stockId=${stockId}`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getStocksByRoomId = async (roomId) => {
  try {
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/stock/byRoom/${roomId}`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getStocksFiltered = async (body) => {
  try {
    const resp = await axios.post(
      `${API_INVENTORY_BASE_URL}/stock/filtered`,
      body
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const assignStockToWarehouse = async (body) => {
  try {
    const resp = await axios.post(`${API_INVENTORY_BASE_URL}/stock`, body);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const updateStockQuantity = async (body) => {
  try {
    let url = `${API_INVENTORY_BASE_URL}/stock/quantityChange?stockId=${body.stockId}&quantity=${body.quantity}&description=${body.description}`;
    if (body.taskId) {
      url += `&taskId=${body.taskId}`;
    }
    const resp = await axios.put(url, {});
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const updateStockStar = async (body) => {
  try {
    const resp = await axios.post(
      `${API_INVENTORY_BASE_URL}/stock/stared?stockId=${body.stockId}&add=${body.star}`,
      {}
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const updateSubStockQuantity = async (body) => {
  try {
    const resp = await axios.put(
      `${API_INVENTORY_BASE_URL}/stock/subQuantityChange`,
      body
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const updateStockUtilizedWasted = async (body) => {
  try {
    const { taskId, ...rest } = body;
    let url = `${API_INVENTORY_BASE_URL}/stock/utilizedWasted`;
    if (taskId) {
      url += `?taskId=${taskId}`;
    }
    const resp = await axios.post(url, {taskId, ...rest });
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const updateSubStockUtilizedWasted = async (body) => {
  try {
    const resp = await axios.put(
      `${API_INVENTORY_BASE_URL}/stock/subUtilizedWasted`,
      body
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const stockHoldAutoPo = async (stockId, hold) => {
  try {
    await axios.get(`${API_INVENTORY_BASE_URL}/stock/holdAutoPo`, {
      params: {
        stockId,
        hold,
      },
    });
  } catch (error) {
    throw error;
  }
};

export const updateMinStockReorderQuant = async (body) => {
  try {
    const resp = await axios.post(
      `${API_INVENTORY_BASE_URL}/stock/addMinReorderQuantity`,
      body
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

/**
 * Vehicles
 */

export const getVehicles = async (opts = {}) => {
  try {
    const {
      sortBy = 'name',
      sort = 'asc',
      pageNumber = 0,
      pageSize = 30,
    } = opts;
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/vehicle?sortBy=${sortBy}&sort=${sort}&pageNumber=${pageNumber}&pageSize=${pageSize}`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getVehicle = async (id) => {
  try {
    const resp = await axios.get(`${API_INVENTORY_BASE_URL}/vehicle/${id}`);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const newVehicle = async (data) => {
  try {
    const resp = await axios.post(`${API_INVENTORY_BASE_URL}/vehicle`, data);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const updateVehicle = async (id, data) => {
  try {
    const resp = await axios.put(
      `${API_INVENTORY_BASE_URL}/vehicle/${id}`,
      data
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getVehicleTypes = async () => {
  try {
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/vehicle/vehicleType`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const deleteVehicle = async (id) => {
  try {
    const resp = await axios.delete(
      `${API_INVENTORY_BASE_URL}/vehicle?vehicleId=${id}`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getVehiclePhotos = async (id) => {
  try {
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/vehicle/media/photo/${id}`,
      { responseType: 'blob' }
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getVehicleNumplatePhotos = async (id) => {
  try {
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/vehicle/media/numberplate/${id}`,
      { responseType: 'blob' }
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const uploadVehiclePhotos = async (id, body) => {
  try {
    const resp = await axios.post(
      `${API_INVENTORY_BASE_URL}/vehicle/media/photo/${id}`,
      body,
      {
        headers: {
          'content-type': 'multipart/form-data',
        },
      }
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const uploadVehicleNumplatePhotos = async (id, body) => {
  try {
    const resp = await axios.post(
      `${API_INVENTORY_BASE_URL}/vehicle/media/numberplate/${id}`,
      body,
      {
        headers: {
          'content-type': 'multipart/form-data',
        },
      }
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

/**
 * Company Details
 */

export const newCompanyDetails = async (data) => {
  try {
    const resp = await axios.post(
      `${API_INVENTORY_BASE_URL}/companyName`,
      data
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const updateCompanyDetails = async (id, data) => {
  try {
    const resp = await axios.put(`${API_INVENTORY_BASE_URL}/companyName`, data);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getCompanyDetails = async () => {
  try {
    const resp = await axios.get(`${API_INVENTORY_BASE_URL}/companyName`);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getOneCompanyDetails = async (id) => {
  try {
    const resp = await axios.get(`${API_INVENTORY_BASE_URL}/companyName/${id}`);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const deleteCompanyDetails = async (id) => {
  try {
    const resp = await axios.delete(
      `${API_INVENTORY_BASE_URL}/companyName/${id}`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

/**
 * Logistics
 */

export const getLogistics = async (opts = {}) => {
  try {
    const {
      sortBy = 'roomName',
      sort = 'asc',
      pageNumber = 0,
      pageSize = 20,
      fromSiteIds = [],
      toSiteIds = [],
    } = opts;
    let url = `${API_INVENTORY_BASE_URL}/logistics?sortBy=${sortBy}&sort=${sort}&pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (fromSiteIds.length) {
      url += `&fromSiteIds=${fromSiteIds}`;
    }
    if (toSiteIds.length) {
      url += `&toSiteIds=${toSiteIds}`;
    }
    const resp = await axios.get(url);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const newLogistic = async (data) => {
  try {
    const resp = await axios.post(`${API_INVENTORY_BASE_URL}/logistics`, data);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const updateLogistic = async (data) => {
  try {
    const resp = await axios.put(`${API_INVENTORY_BASE_URL}/logistics`, data);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const updateProgressLogistics = async (id, status) => {
  try {
    const resp = await axios.put(
      `${API_INVENTORY_BASE_URL}/logistics?logisticsId=${id}&logisticsProgressEnum=${status}`,
      {}
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const logisticsDeliveryComplete = async (id) => {
  try {
    const resp = await axios.put(
      `${API_INVENTORY_BASE_URL}/logistics/deliveryComplete?logisticsId=${id}`,
      {}
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getOneLogistic = async (id) => {
  try {
    const resp = await axios.get(`${API_INVENTORY_BASE_URL}/logistics/${id}`);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getLogisticsSchedule = async (id) => {
  try {
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/logistics/driverVehicleSchedule/${id}`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const deleteLogistic = async (id) => {
  try {
    const resp = await axios.delete(
      `${API_INVENTORY_BASE_URL}/logistics/${id}`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getLogisticsByWorkOrder = async (id) => {
  try {
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/logistics/byMaterialIndentId/${id}`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const logisticsAddDriversAndVehicles = async (data) => {
  try {
    const resp = await axios.put(
      `${API_INVENTORY_BASE_URL}/logistics/addDriverAndVehicles`,
      data
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const completeLogistic = async (body) => {
  try {
    const resp = await axios.put(
      `${API_INVENTORY_BASE_URL}/completion/completeLogistics`,
      body
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

/**
 * User Util
 */

export const getUnusedDriverVehicles = async (from, to) => {
  try {
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/userUtil/unusedDriversAndVehicles?fromDate=${from}&toDate=${to}`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const userUtilMediaUpload = async (id, data) => {
  try {
    const resp = await axios.post(
      `${API_INVENTORY_BASE_URL}/userUtil/media/${id}`,
      data,
      {
        headers: {
          'content-type': 'multipart/form-data',
        },
      }
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getUserUtilMedia = async (id) => {
  try {
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/userUtil/media/${id}`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

/**
 * Payments
 */

export const newPoPayment = async (body) => {
  try {
    const resp = await axios.post(`${API_INVENTORY_BASE_URL}/poPayments`, body);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const poPaymentDone = async (woId) => {
  try {
    const resp = await axios.put(
      `${API_INVENTORY_BASE_URL}/poPayments/paymentdone/${woId}`,
      {}
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const updatePoPayment = async (id, data) => {
  try {
    const resp = await axios.put(
      `${API_INVENTORY_BASE_URL}/poPayments/${id}`,
      data
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getPoByPaymentId = async (id) => {
  try {
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/poPayments/poPayments/${id}`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getPoByWoId = async (woId) => {
  try {
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/poPayments/workOrder/${woId}`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getPoPdf = async (poId) => {
  try {
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/workOrder/getPdf?poId=${poId}`,
      { responseType: 'blob' }
    );
    return resp.data;
  } catch (error) {
    throw error;
  }
};

export const getPoBillPdf = async (billId) => {
  try {
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/poBill/getPdf?poBillId=${billId}`,
      { responseType: 'blob' }
    );
    return resp.data;
  } catch (error) {
    throw error;
  }
};

export const getExchangeReturnStock = async (workOrderId) => {
  try {
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/workOrder/exchangeReturnStock/${workOrderId}`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};
export const getStockIssue = async (opts = {}) => {
  try {
    const {
      sortBy = 'createdOn',
      sort = 'desc',
      pageNumber = 0,
      pageSize = 100,
      status = '',
    } = opts;
    let url = `${API_INVENTORY_BASE_URL}/issueStock?sortBy=${sortBy}&sort=${sort}&pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (status) {
      url += `&status=${status}`;
    }
    const resp = await axios.get(url);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const updateStockIssueStatus = async (id, data) => {
  try {
    const resp = await axios.put(
      `${API_INVENTORY_BASE_URL}/issueStock/${id}`,
      data
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const returnStockIssue = async (id, detailId, qty) => {
  try {
    const resp = await axios.put(
      `${API_INVENTORY_BASE_URL}/issueStock/Return/${id}`,
      { detailId, returnQty: parseFloat(qty) }
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const wasteStockIssue = async (id, detailId, qty) => {
  try {
    const resp = await axios.put(
      `${API_INVENTORY_BASE_URL}/issueStock/wasted/${id}`,
      { detailId, wasteQty: parseFloat(qty) }
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const createStockIssue = async (data) => {
  try {
    const resp = await axios.post(`${API_INVENTORY_BASE_URL}/issueStock`, data);
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getStockIssueByTask = async (taskId, pageNumber = 0, pageSize = 20) => {
  try {
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/issueStock/byTask?taskId=${taskId}&pageNumber=${pageNumber}&pageSize=${pageSize}`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};


// mi suggestions 

export const getMiIdsByDecision = ({
  type,
  pageNumber = 0,
  pageSize = 10,
  searchStr = '',
  projectId,
}) => {
  const params = { type, pageNumber, pageSize, searchStr };

  if (projectId !== undefined && projectId !== null && Number(projectId) !== -1) {
    params.projectId = projectId;
  }

  return axios
    .get(`${API_INVENTORY_BASE_URL}/materialIndent/miIdsByDecision`, {
      params,
    })
    .then((res) => res.data);
};

export const getItemsByDecision = ({ type, miId }) =>
  axios
    .post(`${API_INVENTORY_BASE_URL}/materialIndent/itemsByDecision`, {
      type,
      miId: Array.isArray(miId) ? miId : [miId],
    })
    .then((res) => res.data);

export const getStockDetailsByMaterialIndentId = async (materialIndentId) => {
  try {
    const resp = await axios.get(
      `${API_INVENTORY_BASE_URL}/stock/byInventoryDetailsId/${materialIndentId}`
    );
    if (resp.data?.pmsExceptionCode) {
      throw resp.data;
    } else {
      return resp.data;
    }
  } catch (error) {
    throw error;
  }
};

